import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FeedbackService } from '../services/feedback.service';
import { UserService } from '../user_and_auth/user.service';

@Component({
  selector: 'app-feedback-dialog',
  standalone: false,
  template: `
    <h2 mat-dialog-title>Send Feedback</h2>
    <mat-dialog-content>
      <p class="feedback-hint">Report a bug, suggest a feature, or ask a question.</p>
      <mat-form-field class="feedback-field">
        <mat-label>Your message</mat-label>
        <textarea matInput [(ngModel)]="message" rows="5" maxlength="1500"
                  placeholder="Describe the issue or your idea..."></textarea>
        <mat-hint align="end">{{ message.length }}/1500</mat-hint>
      </mat-form-field>
      <mat-form-field class="feedback-field">
        <mat-label>Contact (optional)</mat-label>
        <input matInput [(ngModel)]="contact" maxlength="100"
               placeholder="Discord handle is best" />
        <mat-hint>Without this I can't reply — but it's not required</mat-hint>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary" (click)="submit()" [disabled]="!message.trim() || sending">
        {{ sending ? 'Sending…' : 'Send' }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content { display: flex; flex-direction: column; }
    .feedback-hint { margin: 0 0 12px; font-size: 0.875rem; opacity: 0.7; }
    .feedback-field { width: 100%; min-width: 360px; }
    @media (max-width: 480px) { .feedback-field { min-width: unset; } }
  `],
})
export class FeedbackDialogComponent {
  message = '';
  contact = '';
  sending = false;

  private dialogRef = inject(MatDialogRef<FeedbackDialogComponent>);
  private snackBar = inject(MatSnackBar);
  private feedbackService = inject(FeedbackService);
  private userService = inject(UserService);

  async submit(): Promise<void> {
    if (!this.message.trim() || this.sending) return;
    this.sending = true;
    const user = this.userService.user();
    try {
      await this.feedbackService.send(this.message.trim(), user?.user_displayname, this.contact.trim() || undefined);
      this.snackBar.open('Feedback sent — thank you!', undefined, { duration: 4000 });
      this.dialogRef.close();
    } catch {
      this.snackBar.open('Failed to send feedback. Please try again.', 'OK', { duration: 6000 });
      this.sending = false;
    }
  }
}
